const isMobile = (): boolean => {
  const resolution = window.innerWidth

  return resolution < 768
}

export default isMobile
